export default ['read:current_user', 'update:current_user_metadata'];
